module.exports = "<div>\r\n    <div>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 480
// module chunks = 0